export function isRouteAuthorized(route, access) {
  if (!route || !route.name) return true
  if (!route.meta || !route.meta.requireAuth) return true
  if (!access || !access.loaded) return false
  return access.routeNames.indexOf(route.name) > -1
}



// WEBPACK FOOTER //
// ./src/libs/menuPermission.js